import React from 'react';
import { Box, Card, CardContent, Skeleton } from '@mui/material';

const LoadingGrid: React.FC = () => {
  return (
    <Box sx={{ 
      display: 'grid', 
      gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }, 
      gap: 4 
    }}>
      {[...Array(6)].map((_, index) => (
        <Card key={index} sx={{ borderRadius: '16px', overflow: 'hidden' }}>
          <Skeleton variant="rectangular" height={220} />
          <CardContent>
            <Skeleton variant="text" height={32} width="80%" />
            <Skeleton variant="text" height={20} width="100%" />
            <Skeleton variant="text" height={20} width="60%" />
            <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
              <Skeleton variant="rectangular" height={24} width={60} sx={{ borderRadius: '12px' }} />
              <Skeleton variant="rectangular" height={24} width={80} sx={{ borderRadius: '12px' }} />
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default LoadingGrid;
